module.exports = __webpack_public_path__ + "static/images/my-xy.67f5d3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/flat/pc/my-xy.png
// module id = 393
// module chunks = 1